const initialState = {
	isAuthenticated: false,
	user: null,
};

export default initialState;
